import Axios from "axios";
var ShoppingManageService = (function () {
    function ShoppingManageService() {
    }
    ShoppingManageService.prototype.configShow = function (params) {
        return Axios.get("supplierclientapi/shoppingconfig/show", { params: params });
    };
    ShoppingManageService.prototype.configSave = function (data) {
        return Axios.post("supplierclientapi/shoppingconfig/save", data);
    };
    ShoppingManageService.prototype.updateMpConfig = function (data) {
        return Axios.post("supplierclientapi/shoppingconfig/update_mp_config", data);
    };
    ShoppingManageService.prototype.getListPurchasetime = function (params) {
        return Axios.get("supplierclientapi/shoppingpurchasetime/list", { params: params });
    };
    ShoppingManageService.prototype.delPurchasetime = function (params) {
        return Axios.get("supplierclientapi/shoppingpurchasetime/delete", { params: params });
    };
    ShoppingManageService.prototype.getDetailPurchasetime = function (params) {
        return Axios.get("supplierclientapi/shoppingpurchasetime/detail", { params: params });
    };
    ShoppingManageService.prototype.addSavePurchasetime = function (data) {
        return Axios.post("supplierclientapi/shoppingpurchasetime/create", data);
    };
    ShoppingManageService.prototype.editSavePurchasetime = function (data) {
        return Axios.post("supplierclientapi/shoppingpurchasetime/update", data);
    };
    ShoppingManageService.prototype.decorationShow = function (params) {
        return Axios.get("supplierclientapi/shoppingdecoration/show", { params: params });
    };
    ShoppingManageService.prototype.decorationSave = function (data) {
        return Axios.post("supplierclientapi/shoppingdecoration/save", data);
    };
    ShoppingManageService.prototype.decorationSaveItem = function (data) {
        return Axios.post("supplierclientapi/shoppingdecoration/save_once", data);
    };
    ShoppingManageService.prototype.decorationCategory = function (params) {
        return Axios.get("supplierclientapi/shoppingdecoration/goods_category", { params: params });
    };
    ShoppingManageService.prototype.activityPriview = function (params) {
        return Axios.get("supplierclientapi/shoppingdecoration/goods_preview", { params: params });
    };
    ShoppingManageService.prototype.getMiniappAuthUrl = function (params) {
        return Axios.get('supplierclientapi/openwechat/get_auth_url', { params: params });
    };
    ShoppingManageService.prototype.getMiniappVersionInfo = function (params) {
        return Axios.get('supplierclientapi/openwechat/getversioninfo', { params: params });
    };
    ShoppingManageService.prototype.getMiniappCategory = function (params) {
        return Axios.get('supplierclientapi/openwechat/getcategory', { params: params });
    };
    ShoppingManageService.prototype.getMiniappPrivacySetting = function (params) {
        return Axios.get('supplierclientapi/openwechat/getprivacysetting', { params: params });
    };
    ShoppingManageService.prototype.setMiniappPrivacySetting = function (params) {
        return Axios.post('supplierclientapi/openwechat/setprivacysetting', params);
    };
    ShoppingManageService.prototype.setMiniappCommit = function (params) {
        return Axios.post('supplierclientapi/openwechat/commit', params);
    };
    ShoppingManageService.prototype.setMiniappSubmit = function (params) {
        return Axios.post('supplierclientapi/openwechat/submit', params);
    };
    ShoppingManageService.prototype.getMiniappExpQrcode = function (params) {
        return Axios.get('supplierclientapi/openwechat/getexpqrcode', { params: params });
    };
    ShoppingManageService.prototype.setMiniappRelease = function (params) {
        return Axios.get('supplierclientapi/openwechat/release', { params: params });
    };
    ShoppingManageService.prototype.setMiniappDownline = function (params) {
        return Axios.get('supplierclientapi/openwechat/downline', { params: params });
    };
    ShoppingManageService.createInstance = function () {
        ShoppingManageService.getInstance();
    };
    ShoppingManageService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return ShoppingManageService;
}());
export default ShoppingManageService;
